/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Box, Heading } from 'grommet';

export namespace PageSectionHeader {
  export interface Props {
    title: string;
  }
}
export const PageSectionHeader: React.FC<PageSectionHeader.Props> = ({ title }) => {
  return (
    <Box>
      <Heading level={2} size="small">
        {title}
      </Heading>
      <Box background="sky" height="4px" margin={{ bottom: 'medium', top: 'xxsmall' }} width="40px" />
    </Box>
  );
};
